const Topics = ({ call }) => {
    const { call_score: callScore = {} } = call || {};

    const { topic_coverage: topicCoverage = [] } = callScore || {};

    function formatTagLabel(kebabStr) {
        if (typeof kebabStr !== 'string') return '';

        const words = kebabStr.split('-');
        if (words.length === 0) return '';

        // Capitalize the first word's first letter and join with spaces
        const formatted = words
            .map((word, index) => index === 0
                ? word.charAt(0).toUpperCase() + word.slice(1)
                : word)
            .join(' ');

        return formatted;
    }

    if(!topicCoverage?.length) {
        return null;
    }

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
            <h2 className="text-sm font-semibold text-gray-900 mb-3">Topics Discussed</h2>
            <div className="flex flex-wrap gap-2">
                {/* {!topicCoverage?.length && (
                    <span className="inline-flex items-center px-2 py-1 text-xs font-medium bg-gray-50 text-gray-800 border border-gray-200 rounded-md">
                        
                    </span>
                )} */}
                {topicCoverage?.map((topic) => (
                    <span key={topic} className="inline-flex items-center px-2 py-1 text-xs font-medium bg-gray-50 text-gray-800 border border-gray-200 rounded-md">
                        {formatTagLabel(topic)}
                    </span>
                ))}
            </div>
        </div>
    )
}

export default Topics;